<div id="quick-view-dialog" class="dialog">
  <div class="dialog-top-row">
    <mat-icon class="dialog-close" [mat-dialog-close]="">close</mat-icon>
  </div>

  <app-product-listing [isQuickView]="true" [product]="data.product"> </app-product-listing>
</div>
